import { useSiteInfo } from 'shared'
import getAllLocaleInfo from '../helpers/get-all-locale-info'

const useAllLocaleInfo = () => {
  const siteInfo = useSiteInfo()

  return getAllLocaleInfo(siteInfo?.layout ?? 'icl')
}

export default useAllLocaleInfo
